import * as React from 'react'

import { ArrowRightFromLine } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '~/client/src/shared/components/shadcn-ui/dropdown-menu'
import { getWorkflowStepDisplayName } from '~/client/src/shared/localization/enumDisplayTexts'

import FieldMappingScreenStore from './FieldMappingScreen.store'

interface IProps {
  fieldId: string
  store: FieldMappingScreenStore
}

function StepSelect({ fieldId, store }: IProps): JSX.Element {
  const currentStepIndex = store.getEffectiveStepIndex(fieldId)
  const availableSteps = store.getAvailableStepsForField(fieldId)
  const allDisabled = availableSteps.filter(s => !s.disabled).length <= 1

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        disabled={allDisabled}
        render={
          <Button variant="ghost" size="icon-xs" disabled={allDisabled} />
        }
      >
        <ArrowRightFromLine className="tw:size-3.5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="bottom" className="tw:w-44">
        <DropdownMenuGroup>
          <DropdownMenuLabel>Move to step</DropdownMenuLabel>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          {availableSteps.map(s => {
            const isCurrent = s.index === currentStepIndex
            return (
              <DropdownMenuItem
                key={s.index}
                disabled={s.disabled || isCurrent}
                onClick={() => store.moveFieldToStep(fieldId, s.index)}
                className={isCurrent ? 'tw:font-medium' : ''}
              >
                {getWorkflowStepDisplayName(s.type)}
                {isCurrent && (
                  <span className="tw:ml-auto tw:text-xs tw:text-muted-foreground">
                    current
                  </span>
                )}
              </DropdownMenuItem>
            )
          })}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default observer(StepSelect)
